import { AddInData } from "@fairfleet/geotab";
import { compress, decompress } from "compress-json";
import LZString from "lz-string";

/**
 * Takes any JSON-able object, runs compress-json to dedupe
 * repeated values/keys, then LZ-string to shrink *all* the text.
 */
export function compressData(data: object): { cmp: string } {
  const sanitized = JSON.parse(JSON.stringify(data, (_, v) => (v === undefined ? null : v)));
  const deduped = compress(sanitized);
  const json = JSON.stringify(deduped);
  return { cmp: LZString.compressToUTF16(json) };
}

/**
 * If you pass in an object created by compressData,
 * this will restore your original object. Otherwise,
 * if it's a string, try to parse it as JSON.
 */
export function decompressData<T>(input: unknown): T {
  if (
    typeof input === "object" &&
    input !== null &&
    "cmp" in input &&
    typeof (input as any).cmp === "string"
  ) {
    const jsonStr = LZString.decompressFromUTF16((input as any).cmp);
    if (jsonStr == null) console.error("Corrupt compressed payload");
    return decompress(JSON.parse(jsonStr)) as T;
  }

  if (typeof input === "string") {
    try {
      return JSON.parse(input) as T;
    } catch {
      return input as unknown as T;
    }
  }

  return input as T;
}

export function decompressAddIn(addIn: AddInData): AddInData {
  return {
    ...addIn,
    details: decompressData(addIn.details),
  };
}

export function decompressAddIns(addIns: AddInData[]): AddInData[] {
  return addIns.map(addIn => decompressAddIn(addIn));
}
